module.exports = __webpack_public_path__ + "img/videos_library.34fb98b5.png";